function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

// Threshold for swipe delta when event is triggered
import { jsx as ___EmotionJSX } from "@emotion/core";
var DELTA_SWIPE_THRESHOLD = 60;

// We have scroll delay effect to compensate for the async nature of react.
export var SCROLL_EFFECT_DELAY = 500;
var ScrollDrag = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dragging = _useState2[0],
    setDragging = _useState2[1];
  var _useState3 = useState(props.dragEnabled),
    _useState4 = _slicedToArray(_useState3, 2),
    dragEnabled = _useState4[0],
    setDragEnabled = _useState4[1];
  var _useState5 = useState({
      startScrollLeft: 0,
      dragStartX: 0
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    scrollMeta = _useState6[0],
    setScrollMeta = _useState6[1];
  var touchStartX = useRef(0);
  var disableDragging = () => setDragging(false);
  useEffect(() => {
    setDragEnabled(props.dragEnabled);
  }, [props.dragEnabled]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('mouseup', disableDragging);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('mouseup', disableDragging);
      }
    };
  }, []);
  var onScrollFinished = isDirectionLeft => {
    if (ref.current) {
      props.onScrollFinished(isDirectionLeft);
    }
  };
  var onSwipeStart = evt => {
    touchStartX.current = evt.clientX || evt.touches[0].clientX;
  };
  var onSwipeEnd = evt => {
    var delta = (evt.clientX || evt.changedTouches[0].clientX) - touchStartX.current;
    var isDirectionLeft = delta > 0;
    if (Math.abs(delta) > DELTA_SWIPE_THRESHOLD) {
      if (isDirectionLeft) {
        props.onSwipeLeft();
      } else {
        props.onSwipeRight();
      }
    }
    onScrollFinished(isDirectionLeft);
  };
  var handleMouseMove = evt => {
    if (dragging) {
      var dragStartX = scrollMeta.dragStartX,
        startScrollLeft = scrollMeta.startScrollLeft;
      // eslint-disable-next-line no-param-reassign
      ref.current.scrollLeft = startScrollLeft + dragStartX - evt.clientX;
      props.onScrollStarted();
    }
  };
  var handleMouseDown = evt => {
    if (dragEnabled) {
      setDragging(true);
      setScrollMeta({
        startScrollLeft: ref.current.scrollLeft,
        dragStartX: evt.clientX
      });
      onSwipeStart(evt);
    }
  };
  var handleMouseUp = evt => {
    if (dragging) {
      setDragging(false);
      setScrollMeta({
        startScrollLeft: 0,
        dragStartX: 0
      });
      onSwipeEnd(evt);
    }
  };
  return ___EmotionJSX("div", {
    ref: ref,
    role: "button",
    tabIndex: "0",
    onTouchEnd: onSwipeEnd,
    onTouchStart: onSwipeStart,
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    onMouseMove: handleMouseMove,
    className: props.className
  }, props.children);
});
ScrollDrag.propTypes = {
  onSwipeLeft: PropTypes.func,
  onSwipeRight: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  dragEnabled: PropTypes.bool,
  onScrollStarted: PropTypes.func,
  onScrollFinished: PropTypes.func
};
ScrollDrag.defaultProps = {
  onSwipeLeft: () => {},
  onSwipeRight: () => {},
  onScrollStarted: () => {},
  onScrollFinished: () => {},
  className: '',
  dragEnabled: true
};
export default ScrollDrag;